var _rect, _g, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXml(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "url(#paint0_linear_1624_48554)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9691 5.92452C18.0828 5.54748 17.8754 5.14779 17.5059 5.03178C17.1364 4.91576 16.7447 5.12737 16.631 5.5044L11.031 24.0755C10.9173 24.4525 11.1247 24.8522 11.4942 24.9682C11.8637 25.0842 12.2554 24.8726 12.3691 24.4956L17.9691 5.92452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.095 9.49501C10.3683 9.77395 10.3683 10.2262 10.095 10.5051L5.68995 15L10.095 19.4948C10.3683 19.7738 10.3683 20.226 10.095 20.505C9.82161 20.7839 9.37839 20.7839 9.10503 20.505L4.20503 15.5051C3.93166 15.2261 3.93166 14.7739 4.20503 14.4949L9.10503 9.49501C9.37839 9.21607 9.82161 9.21607 10.095 9.49501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.905 9.49501C18.6317 9.77395 18.6317 10.2262 18.905 10.5051L23.3101 15L18.905 19.4948C18.6317 19.7738 18.6317 20.226 18.905 20.505C19.1784 20.7839 19.6216 20.7839 19.895 20.505L24.795 15.5051C25.0683 15.2261 25.0683 14.7739 24.795 14.4949L19.895 9.49501C19.6216 9.21607 19.1784 9.21607 18.905 9.49501Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9691 6.92452C19.0828 6.54748 18.8754 6.14779 18.5059 6.03178C18.1364 5.91576 17.7447 6.12737 17.631 6.5044L12.031 25.0755C11.9173 25.4525 12.1247 25.8522 12.4942 25.9682C12.8637 26.0842 13.2554 25.8726 13.3691 25.4956L18.9691 6.92452Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.095 10.495C11.3683 10.774 11.3683 11.2262 11.095 11.5051L6.68995 16L11.095 20.4948C11.3683 20.7738 11.3683 21.226 11.095 21.505C10.8216 21.7839 10.3784 21.7839 10.105 21.505L5.20503 16.5051C4.93166 16.2261 4.93166 15.7739 5.20503 15.4949L10.105 10.495C10.3784 10.2161 10.8216 10.2161 11.095 10.495Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.905 10.495C19.6317 10.774 19.6317 11.2262 19.905 11.5051L24.3101 16L19.905 20.4948C19.6317 20.7738 19.6317 21.226 19.905 21.505C20.1784 21.7839 20.6216 21.7839 20.895 21.505L25.795 16.5051C26.0683 16.2261 26.0683 15.7739 25.795 15.4949L20.895 10.495C20.6216 10.2161 20.1784 10.2161 19.905 10.495Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1624_48554",
    x1: 0,
    y1: 0,
    x2: 32.0449,
    y2: 0.0450633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A7C69"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXml);
export default __webpack_public_path__ + "static/media/xml.f655d3bd90d9ce3b9eb163e27b12212a.svg";
export { ForwardRef as ReactComponent };